<template>
  <section class="about-asked-question">
    <div class="about-asked-question__content">
      <h3 class="about-asked-question__title">よくいただくご質問</h3>
      <div class="about-asked-question__description">
        <div class="about-asked-question__question-and-answer">
          <h4 class="about-asked-question__sub-title">
            <span>申し込みからギフトURLが納品されるまでには、</span>
            <span>どのくらいの日数がかかりますか？</span>
          </h4>
          <p class="about-asked-question__text">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            A. 最短で進行した場合、<b>3営業日程度で納品が可能</b>です。お申し込みから請求書の発行までに最大3営業日、請求書に基づいてお客様からご入金をいただき（請求書発行からご入金までは、5営業日以内でのご対応をお願いしております）確認ができましたら、そこから最大3営業日以内にギフトURLを納品いたします。
          </p>
          <p class="about-asked-question__text">
            ※お申し込み内容に不備があったり希望商品に在庫切れがあった場合には、上記に記載した以上のお時間をいただく場合がございます。
          </p>
        </div>
        <div class="about-asked-question__question-and-answer">
          <h4 class="about-asked-question__sub-title">
            <span>一度の申し込みで複数のパターンのギフトカードを</span>
            <span>発注することができますか？</span>
          </h4>
          <p class="about-asked-question__text">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            A. 基本的には<b>一度に何パターンでもお申し込みが可能</b>です。下記は申し込み画面のイメージですが、右上の「ギフトカード追加」ボタンでパターンを増やしていくことができます。パターンごとに、ご自身でわかりやすい名称をつけていただくことも可能です。
          </p>
          <p class="about-asked-question__text">
            （例）同僚用のカード、上司用のカード…など
          </p>
          <div class="about-asked-question__gift-card-list-image--wrapper">
            <ImgLazy
              :image-url="BulkOrderGiftCardListImage"
              alt-text="ギフトカードリスト画面"
              aspect-ratio="723 / 1885"
              class="about-asked-question__gift-card-list-image"
            />
          </div>
        </div>
        <div class="about-asked-question__question-and-answer">
          <h4 class="about-asked-question__sub-title">
            <span>まとめてオーダーで選べるギフトと</span>
            <span>通常gifteeで選べるギフトには違いがありますか？</span>
          </h4>
          <p class="about-asked-question__text">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            A. <b>掲載中のギフトはすべてお選びいただけます。</b>ただしその時々で、ブランド様のご事情で販売停止していたり、在庫数が不足している場合もございますのでご了承ください。
          </p>
        </div>
        <div class="about-asked-question__question-and-answer">
          <h4 class="about-asked-question__sub-title">
            <span>納品されたURLをメール等で送る以外に、</span>
            <span>便利な配布方法があれば教えてください。</span>
          </h4>
          <p class="about-asked-question__text">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            A.納品されたURLで<b>QRコードを作成・印刷し、それを貼り付けた紙のカードを手渡しで配る</b>方法もございます。
          </p>
          <div class="about-asked-question__delivery-methods--wrapper">
            <div class="about-asked-question__delivery-methods">
              <ImgLazy
                :image-url="DeliveryMethod1Image"
                alt-text="名刺の裏にQRコードを貼り付けて配布"
                aspect-ratio="868 / 487"
                class="about-asked-question__delivery-methods--image"
              />
              <div class="about-asked-question__delivery-methods--description">
                <p
                  class="about-asked-question__delivery-methods--caption-title"
                >
                  名刺の裏に
                </p>
                <p
                  class="about-asked-question__delivery-methods--caption-description"
                >
                  今後お世話になる方へ「お仕事おつかれさまです」のキモチを込めて、コーヒー1杯の差し入れを
                </p>
              </div>
            </div>
            <div class="about-asked-question__delivery-methods">
              <ImgLazy
                :image-url="DeliveryMethod2Image"
                alt-text="お手紙の中にQRコードを貼り付けて紙のカードを入れて配布"
                aspect-ratio="868 / 487"
                class="about-asked-question__delivery-methods--image"
              />
              <div class="about-asked-question__delivery-methods--description">
                <p
                  class="about-asked-question__delivery-methods--caption-title"
                >
                  お手紙の中に
                </p>
                <p
                  class="about-asked-question__delivery-methods--caption-description"
                >
                  そっとギフトを忍ばせて、応援のキモチを伝えよう
                </p>
              </div>
            </div>
          </div>
          <p class="about-asked-question__text">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            gifteeの運営スタッフが、実際にこの方法を試してみた事例を紹介しているコラムがありますので、参考にしていただけますと幸いです。
          </p>
          <div class="about-asked-question__button">
            <a class="btn btn--secondary" href="/announcements/377">
              コラムを読む
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import BulkOrderGiftCardListImage from '../../../../../../images/bulk_personal_orders/about/bulk_order_gift_card_list.png'
import DeliveryMethod1Image from '../../../../../../images/bulk_personal_orders/about/delivery_method1.png'
import DeliveryMethod2Image from '../../../../../../images/bulk_personal_orders/about/delivery_method2.png'
</script>

<style lang="scss" scoped>
.about-asked-question {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1440px;
    padding: 96px 72px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 56px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 64px 24px;
    }
  }

  &__title {
    color: $black;
    font-weight: bold;
    font-size: 4.8rem;
    line-height: 1.29;
    margin-bottom: 48px;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
      line-height: 1;
    }
  }

  &__description {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 648px;
    width: 100%;
    gap: 48px;

    @media all and (max-width: ($pc-width - 1)) {
      max-width: 800px;
      padding: 0 56px;
      gap: 56px;
      box-sizing: border-box;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 0;
    }
  }

  &__question-and-answer {
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    min-height: 293px;

    @media all and (max-width: ($pc-width - 1)) {
      min-height: auto;
    }
  }

  &__sub-title {
    font-size: 2rem;
    font-weight: bold;
    color: $black;
    line-height: 1.4;
    border-bottom: 4px solid $primary-highlight;
    padding-bottom: 32px;
    margin-bottom: 32px;

    @media all and (max-width: ($pc-width - 1)) {
      padding-bottom: 24px;
      margin-bottom: 24px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      font-size: 1.4rem;
      line-height: 1.43;
    }

    & > span {
      display: block;
    }
  }

  &__text {
    font-size: 1.4rem;
    color: $black;
    line-height: 1.6;
    text-align: left;

    & > b {
      font-weight: bold;
      color: $primary;
    }
  }

  &__button {
    margin-top: 32px;

    @media all and (max-width: ($pc-width - 1)) {
      margin-top: 24px;
    }

    & > a {
      width: 215px;
      display: inline-block;
    }
  }

  &__gift-card-list-image {
    margin: auto;
    width: 240px;
    object-fit: contain;

    @media all and (max-width: ($pc-width - 1)) {
      width: 400px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      width: 100%;
      max-width: 396px;
    }

    &--wrapper {
      margin-top: 32px;

      @media all and (max-width: ($base-contents-width - 1)) {
        margin-top: 24px;
        padding: 0 64px;
      }
    }
  }

  &__delivery-methods {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    width: 100%;

    @media all and (max-width: ($base-contents-width - 1)) {
      max-width: 396px;
      flex-direction: column;
      gap: 8px;
    }

    &--wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 24px;
      margin-top: 32px;
      margin-bottom: 32px;

      @media all and (max-width: ($pc-width - 1)) {
        margin-top: 24px;
        margin-bottom: 24px;
      }

      @media all and (max-width: ($base-contents-width - 1)) {
        gap: 32px;
      }
    }

    &--image {
      width: 100%;
      max-width: 289px;
      object-fit: contain;

      @media all and (max-width: ($base-contents-width - 1)) {
        max-width: 396px;
      }
    }

    &--description {
      flex: 1;
      text-align: left;

      @media all and (max-width: ($base-contents-width - 1)) {
        text-align: center;
      }
    }

    &--caption-title {
      font-weight: bold;
      font-size: 1.4rem;
      line-height: 1.6;
      color: $black;
    }

    &--caption-description {
      font-size: 1.4rem;
      line-height: 1.6;
      color: $black;
    }
  }
}
</style>
